import { render } from "./TonWalletVerification.vue?vue&type=template&id=5387d9a3&scoped=true"
import script from "./TonWalletVerification.vue?vue&type=script&lang=js"
export * from "./TonWalletVerification.vue?vue&type=script&lang=js"

import "./TonWalletVerification.vue?vue&type=style&index=0&id=5387d9a3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5387d9a3"]])

export default __exports__